export enum BookingStatus {
    Available = "Available",
    Booked = "Booked",
    Cancelled = "Cancelled",
    Unavailable = "Unavailable"
}